module.exports = __webpack_public_path__ + "img/Rectangle.a2b31d11.jpg";